import remove from '@mailobj-browser/front/js/tree/remove.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import { handle } from '../form.js'

const handler = ({ button, form }) => {
  const { dataset } = button
  const { contract } = dataset
  const { length } = all(`fieldset:not(:disabled) [data-contract="${contract}"]`, form)
  
  if (!length) {
    remove(form)
  }
}

export default button => {
  handle(button, handler)
}
